import React, {useContext} from 'react';

import {styled} from "@mui/material/styles";

import {BadgeContext} from "../BadgeContext";

// emotion (not legacy @mui/styles JSS): the lists render hundreds of badges,
// and per-instance dynamic JSS stylesheets froze the main thread
const Container = styled('div', {shouldForwardProp: (prop) => 'context' !== prop})(({ theme, context }) => {
    const iconPadding = theme.padding.noLabel.hasIndicator[context.size];
    const noLabelPadding = theme.padding.noLabel[context.size];

    const color  = context.backgroundColor ?? context.color;

    const hasBorder = !!context.border ?? false;

    const hasIcon = !!context.icon;

    let borderRadius = theme.radius.default;

    if (context.rounded === true) {
        borderRadius = theme.radius.rounded;
    } else if (context.rounded === 'soft') {
        borderRadius = theme.radius.soft;
    }

    return ({
        display: 'flex',
        alignItems: hasIcon ? 'center' : 'center',
        gap: '4px',
        width: context.fullWidth ? '100%' : 'fit-content',
        backgroundColor: theme.palette[color]?.light ?? color,
        padding: context.hasLabel ? theme.padding[context.size] : hasIcon ? iconPadding : noLabelPadding,
        borderRadius: borderRadius,
        border: hasBorder ? `1px solid ${context.borderColor ? context.borderColor : theme.border[color]?.main}`: null,
        height: '20px',
        cursor: typeof context.onClick === 'function' ? 'pointer' : 'auto',
        justifyContent: context.centerContent ? 'center' : 'flex-start'
    })
});

function BadgeContainer(props) {
    const context = useContext(BadgeContext);

    return (
        <Container context={context} onClick={context.onClick ?? undefined}>
            {props.children}
        </Container>
    );
}

export default BadgeContainer;
